import { render } from "./MarkUnreadMenu.vue?vue&type=template&id=0cea24c1&scoped=true"
import script from "./MarkUnreadMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkUnreadMenu.vue?vue&type=script&setup=true&lang=js"

import "./MarkUnreadMenu.vue?vue&type=style&index=0&id=0cea24c1&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cea24c1"],['__file',"resources/js/components/whatsapp-managment/includes/components/MarkUnreadMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cea24c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cea24c1', __exports__)) {
    console.log('reload')
    api.reload('0cea24c1', __exports__)
  }
  
  module.hot.accept("./MarkUnreadMenu.vue?vue&type=template&id=0cea24c1&scoped=true", () => {
    console.log('re-render')
    api.rerender('0cea24c1', render)
  })

}


export default __exports__